import en from "./en";
import de from "./de";
import es from "./es";
import pt from "./pt";
import it from "./it";

// Base translations, one file per language. Admin overrides are merged at runtime in the store.
export const DICT = { en, de, es, pt, it };
export const LANGS = ["en", "de", "es", "pt", "it"];
